<script setup lang="ts">
import type { NuxtError } from '#app'
import { useCoreConfig, useRequestURL, ref } from '#imports'
import { getErrorPageUrl, getErrorTemplate } from '@core/shared/errorPageUrl'

const props = defineProps<{
    error: NuxtError
}>()

const config = useCoreConfig()
const { brand, jurisdiction } = config.site

const errorTemplate = getErrorTemplate(props.error.statusCode ?? 500)
const errorPageUrl = errorTemplate
    ? getErrorPageUrl(brand, jurisdiction, errorTemplate, props.error.message)
    : null

const { origin } = useRequestURL()
const errorPageHtml = ref<string | null>(null)

if (errorPageUrl) {
    const html = await $fetch<string>(errorPageUrl, { responseType: 'text' })
    errorPageHtml.value = html.replace('<head>', `<head><base href="${origin}" target="_top">`)
}
</script>

<template>
    <iframe
        v-if="errorPageHtml"
        :srcdoc="errorPageHtml"
        title="Error page"
        style="position: fixed; inset: 0; width: 100%; height: 100%; border: none;"
    />
</template>
